export default {

  refresh (){

    Creek.debug.log("Refreshing content.");

    //Send Google Analytics pageview
    if(typeof ga != 'undefined'){ 
      ga('send', 'pageview', window.location); 
    }

    //Reset Facebook plugins
    if(typeof FB != 'undefined') FB.XFBML.parse();

  }

}